import { generateProductSearchParams } from "../../../../utils/search/utils"
import SearchService from "../../../search/SearchService"
import { isError } from "../../../helpers/Error"

export class Service {
    static async getProductsList(payload) {
        const params = generateProductSearchParams({
            ...payload,
        })

        const res = await SearchService.listingSearch(params)

        if (isError(res)) {
            throw new Error(res.message)
        }

        return res ?? []
    }
}


// WEBPACK FOOTER //
// ./src/state/listing/product/service/service.ts